export default "__VITE_ASSET__Cb4_k$Zn__"